var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRndrIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#CF1011;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1_00000093148588270623327870000010164809315223045310_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1704857643392"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440.6,0c243.2,0,440.6,197.4,440.6,440.6S683.8,881.2,440.6,881.2S0,683.8,0,440.6S197.4,0,440.6,0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.6,336.3c57.5,0,104.3,46.5,104.3,104.3c0,57.5-46.5,104.3-104.3,104.3c-57.5,0-104.3-46.5-104.3-104.3 C336.3,383.2,382.8,336.3,440.6,336.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.1,167.8c32.8,0.4,65.2,6.7,95.5,18.3c30.3,11.6,58.5,28.6,83.2,50.4l0.7,0.7l0,0 c56,50.1,86.7,117.7,90.6,187.2c4.2,69.8-18.3,141-68,197.4l-0.7,0.7l0,0c-50.1,56-117.7,86.7-187.2,90.6 c-69.8,4.2-141-18.3-197.4-68C203.4,595,172.4,527,168.5,457.2c-4.2-69.8,18.3-141,68-197.4l23.6,20.8 c-44.1,49.7-63.8,112.8-60.3,174.5c3.9,61.7,31,122,80.7,166s112.8,63.8,174.5,60.3c61.7-3.9,122-31,166-80.7l0.7-0.7l0,0 c43.7-49.7,63.4-112.4,59.6-173.8c-3.9-61.7-31-122-80.7-166l-0.7-0.7l0,0c-21.5-19-46.2-33.8-72.6-44.1 c-26.8-10.2-55.3-15.9-84.2-16.2l0.4-31.7L443.1,167.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M285.5,169.5c19,0,36,7.8,48.3,20.1c12.3,12.3,20.1,29.6,20.1,48.3c0,19-7.8,36-20.1,48.3 c-12.3,12.3-29.6,20.1-48.3,20.1c-19,0-36-7.8-48.3-20.1c-12.3-12.3-20.1-29.6-20.1-48.3c0-19,7.8-36,20.1-48.3 C249.6,177.3,266.8,169.5,285.5,169.5z M311.6,212.2c-6.7-6.7-15.9-10.9-26.1-10.9s-19.4,4.2-26.1,10.9s-10.9,15.9-10.9,26.1 c0,10.2,4.2,19.4,10.9,26.1s15.9,10.9,26.1,10.9s19.4-4.2,26.1-10.9s10.9-15.9,10.9-26.1C322.5,228.1,318.3,218.9,311.6,212.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRndrIcon);
export default __webpack_public_path__ + "static/media/rndr_icon.87587a7be9405375b1ea593e6f8fa8a2.svg";
export { ForwardRef as ReactComponent };